// extracted by mini-css-extract-plugin
export var large = "styles-module--large--d6429";
export var medium = "styles-module--medium--31467";
export var onlyIcon = "styles-module--onlyIcon--c4756";
export var small = "styles-module--small--4f1c0";
export var x2Large = "styles-module--x2Large--958dc";
export var xLarge = "styles-module--xLarge--4dd30";